import React from 'react';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { getSymbol } from '../../utils/currency';
import { MagnifyingGlass, Check, X, House, Eye, ToggleRight, ToggleLeft, GridFour } from '@phosphor-icons/react';
import { StatusBadge } from './_shared';

const ListingsView = ({ listings, searchQuery, setSearchQuery, statusFilter, setStatusFilter, handleApproveListing, handleRejectListing, handleToggleListingStatus, navigate }) => (
  <div>
    <div className="flex items-center gap-3 mb-6 flex-wrap">
      <div className="relative flex-1 max-w-md">
        <MagnifyingGlass className="absolute left-3 top-1/2 -translate-y-1/2 text-[#6b7a99]" size={16} />
        <Input placeholder="Search listings..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="pl-9 bg-[#161b26] border-[#252d3d] text-white rounded-xl h-9 text-sm" data-testid="search-listings" />
      </div>
      <Select value={statusFilter} onValueChange={setStatusFilter}>
        <SelectTrigger className="w-36 h-9 bg-[#161b26] border-[#252d3d] text-white rounded-xl text-sm"><SelectValue placeholder="All Status" /></SelectTrigger>
        <SelectContent><SelectItem value="all">All Status</SelectItem><SelectItem value="pending">Pending</SelectItem><SelectItem value="live">Live</SelectItem><SelectItem value="paused">Paused</SelectItem><SelectItem value="rejected">Rejected</SelectItem></SelectContent>
      </Select>
    </div>
    <div className="space-y-2">
      {listings.map(l => {
        const capacity = l.total_capacity || l.capacity;
        return (
        <div key={l.listing_id} className="bg-[#161b26] border border-[#252d3d] rounded-xl flex items-center gap-3 px-4 py-3" data-testid={`listing-${l.listing_id}`}>
          <div className="w-12 h-12 bg-[#1e2536] rounded-lg flex items-center justify-center shrink-0 overflow-hidden">
            {l.images?.[0] ? <img src={l.images[0]} alt="" className="w-full h-full object-cover" /> : <House size={20} className="text-[#6b7a99]" />}
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-white text-sm font-medium truncate">{l.title}</h3>
            <p className="text-[#6b7a99] text-xs">{l.category} - {getSymbol(l.currency || l.country)}{l.base_price}/{l.pricing_model} - {l.seller_name}</p>
          </div>
          {capacity && capacity > 1 ? (
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-indigo-500/15 text-indigo-300 text-[11px] font-bold border border-indigo-500/30" title={`Total capacity: ${capacity}`} data-testid={`listing-capacity-${l.listing_id}`}>
              <GridFour size={12} weight="bold" /> {capacity}
            </span>
          ) : null}
          <StatusBadge status={l.status} />
          <div className="flex gap-1.5 items-center">
            {l.status === 'pending' && (<>
              <button onClick={() => handleApproveListing(l.listing_id)} className="w-7 h-7 bg-emerald-500/20 hover:bg-emerald-500/30 rounded-lg flex items-center justify-center" title="Approve" data-testid={`approve-listing-${l.listing_id}`}><Check size={14} className="text-emerald-400" weight="bold" /></button>
              <button onClick={() => handleRejectListing(l.listing_id)} className="w-7 h-7 bg-red-500/20 hover:bg-red-500/30 rounded-lg flex items-center justify-center" title="Reject" data-testid={`reject-listing-${l.listing_id}`}><X size={14} className="text-red-400" weight="bold" /></button>
            </>)}
            {(l.status === 'live' || l.status === 'paused') && (
              <button onClick={() => handleToggleListingStatus(l.listing_id)} title={l.status === 'live' ? 'Deactivate' : 'Activate'}
                className="p-1" data-testid={`toggle-listing-${l.listing_id}`}>
                {l.status === 'live' ? <ToggleRight size={22} className="text-emerald-400" weight="fill" /> : <ToggleLeft size={22} className="text-[#6b7a99]" weight="fill" />}
              </button>
            )}
            <button onClick={() => navigate(`/listing/${l.listing_id}`)} className="p-1.5 text-[#6b7a99] hover:text-white hover:bg-[#252d3d] rounded-lg" data-testid={`view-listing-${l.listing_id}`}><Eye size={16} /></button>
          </div>
        </div>
        );
      })}
    </div>
  </div>
);

export default ListingsView;
